export const UPDATE_INPUT_INTERVALS = 'UPDATE_INPUT_INTERVALS';
export const updateInputIntervals = (payload) => ({
  type: UPDATE_INPUT_INTERVALS,
  payload,
});

export const UPDATE_REQUEST_STATUS_T = 'UPDATE_REQUEST_STATUS_T';
export const updateRequestStatusT = (payload) => ({
  type: UPDATE_REQUEST_STATUS_T,
  payload,
});

export const UPDATE_BUILDING_DATA = 'UPDATE_BUILDING_DATA';
export const updateBuildingData = (payload) => {
  return {
    type: UPDATE_BUILDING_DATA,
    payload,
  };
};

export const CLEAR_FILTERS_TRANSACTIONS = 'CLEAR_FILTERS_TRANSACTIONS';
export const clearFiltersTransactions = () => ({
  type: CLEAR_FILTERS_TRANSACTIONS,
});

export const UPDATE_REALTY_TRANSACTIONS = 'UPDATE_REALTY_TRANSACTIONS';
export const updateRealtyTransactions = (payload) => ({
  type: UPDATE_REALTY_TRANSACTIONS,
  payload,
});

export const IS_ACTIVE = 'IS_ACTIVE';
export const setIsActive = (e) => ({
  type: IS_ACTIVE,
  payload: e,
});

export const UPDATE_REALTY_TRANSACTIONS_FILTERS_ADD =
  'UPDATE_REALTY_TRANSACTIONS_FILTERS_ADD';
export const updateRealtyTransactionsFiltersAdd = (payload) => ({
  type: UPDATE_REALTY_TRANSACTIONS_FILTERS_ADD,
  payload,
});

export const SET_INFOWINDOWS_TRANSACTIONS = 'SET_INFOWINDOWS_TRANSACTIONS';
export const setInfowindowsTransactions = (payload) => ({
  type: SET_INFOWINDOWS_TRANSACTIONS,
  payload,
});

export const ADD_INFOWINDOW_TRANSACTIONS = 'ADD_INFOWINDOW_TRANSACTIONS';
export const addInfowindowTransactions = (payload) => ({
  type: ADD_INFOWINDOW_TRANSACTIONS,
  payload,
});

export const CLOSE_INFOWINDOW_TRANSACTIONS = 'CLOSE_INFOWINDOW_TRANSACTIONS';
export const closeInfowindowTransactions = (payload) => ({
  type: CLOSE_INFOWINDOW_TRANSACTIONS,
  payload,
});

export const SET_LAUNCHING_YEARS_TRANSACTIONS =
  'SET_LAUNCHING_YEARS_TRANSACTIONS';
export const setLaunchingYearsTransactions = (payload) => ({
  type: SET_LAUNCHING_YEARS_TRANSACTIONS,
  payload,
});

export const UPDATE_PAYLOAD_CHARTS_TRANSACTIONS =
  'UPDATE_PAYLOAD_CHARTS_TRANSACTIONS';
export const updatePayloadChartsTransactions = (payload) => ({
  type: UPDATE_PAYLOAD_CHARTS_TRANSACTIONS,
  payload,
});

export const UPDATE_CHARTS_DATA_TRANSACTIONS =
  'UPDATE_CHARTS_DATA_TRANSACTIONS';
export const updateChartsDataTransactions = (payload) => ({
  type: UPDATE_CHARTS_DATA_TRANSACTIONS,
  payload,
});
